<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("CATEGORY_EQUIPMENTS.EDIT_CATEGORY_EQUIPMENT") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button @click="goBack" type="button" class="btn btn-sm btn-primary">
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <category-equipment-form
              :loading="loading"
              :categoryEquipmentData="categoryEquipment"
              :formErrors="formErrors"
              @categoryEquipmentSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryEquipmentForm from "./partials/CategoryEquipmentForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultCategoryEquipment from "./defaultCategoryEquipment";

export default {
  layout: "DashboardLayout",

  components: { CategoryEquipmentForm },

  mixins: [alertLeave],

  data() {
    return {
      categoryEquipment: cloneDeep(defaultCategoryEquipment),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("categoryEquipments/get", id);
        this.categoryEquipment = this.$store.getters[
          "categoryEquipments/categoryEquipment"
        ];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List CategoryEquipments" });
    },

    viewCategoryEquipment() {
      this.alertLeave = false;
      this.$router.push({
        name: "View CategoryEquipment",
        params: { id: this.categoryEquipment.id },
      });
    },

    async handleSubmit(categoryEquipment) {
      try {
        await this.$store.dispatch("categoryEquipments/update", categoryEquipment);
        this.$notify({
          type: "success",
          message: this.$t("CATEGORY_EQUIPMENTS.CATEGORY_EQUIPMENT_UPDATED"),
        });
        this.viewCategoryEquipment();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
